module.exports = __webpack_public_path__ + "static/media/time-file.bad4812b.svg";